import Vue from "vue";
import VueRouter from "vue-router";
import layout from "./../views/layout/layout";
Vue.use(VueRouter);
const Admin = ["Admin"];
const Shop = ["Admin", "Shop"];
const Contact = ["Admin", "Contact"];
const Offer = ["Admin", "Offer"];
const Subscription = ["Admin", "Subscription"];

const routes = [
    {
        path:"/dashboard",
        component: layout,
        meta:{
            roles: Admin
        },
        children: [
            {
                path: "/",
                name: "home",
                meta:{
                    roles: Admin,
                    title:'الرئيسية'
                },
                component: () => import("./../views/pages/home")
            },
            {
                path: "/notification",
                name: "notification",
                meta:{
                    roles: Admin,
                    title:'الإشعارات'
                },
                component: () => import("./../views/pages/notification")
            },
            {

                path: "/smsRecords/",
                name: "smsRecords",
                meta:{
                    roles: Admin,
                    title:'سجل الرسائل'
                },
                component: () => import("./../views/pages/smsrecords"),
                redirect : "/smsRecords/-1",
                 children: [
                    {
                        path: ":id",
                        name: "action subs",
                        meta:{
                            roles: Admin,
                            title:'الإشتراكات - العمليات'
                        },
                        component: () => import("./../views/pages/smsrecords/components/action-account.vue"),
                     }
                ]
                
            },
            {
                name: "notification details with id and shop id",
                path: "/notification/details/:shopId",
                props: true,
                meta:{
                    roles: Admin,
                    title:'اشعارات - تفاصيل'
                },
                component: () => import("./../views/pages/notification/components/details.vue"),
                children:[
                    {
                        path: "active-notification/:notiyId",
                        name: "active notification",
                        meta:{
                            roles: Admin,
                            title:'اشعارات - تفاصيل'
                        },
                        component: () => import("./../views/pages/notification/components/active-notification.vue"),
                        props:true
                    },
                ]
            },
            {
                path: "/ad",
                name: "ad",
                props: true,
                meta:{
                    roles: Offer,
                    title:'الإعلانات والعروض'
                },
                component: () => import("./../views/pages/ad"),
                redirect : "/ad/1/-1",
                children:[
                    {
                        path: ":type/:adIndex",
                        name: "create ad-offer",
                        meta:{
                            roles: Offer,
                            title:'الإعلانات والعروض - عمليات'
                        },
                        component: () => import("./../views/pages/ad/components/create-new.vue"),
                        props:true
                    }
                ]
            },
            {
                path: "/contact",
                name: "contact",
                meta:{
                    roles: Contact,
                    title:'تواصل معنا'
                },
                props: true,
                component: () => import("./../views/pages/contact"),
                redirect: "/contact/customers",
                children: [
                    {
                        path: "customers",
                        name: "customers redirect",
                        meta:{
                            roles: Contact,
                            title:'تواصل معنا - المستفيدون'
                        },
                        components: {
                            table: () => import("./../views/pages/contact/components/customer-table.vue"),
                        }
                    },
                    {
                        path: "/contact/customers/:customersIndex",
                        name: "customers",
                        meta:{
                            roles: Contact,
                            title:'تواصل معنا - المستفيدون - العمليات'
                        },
                        props:{
                            table: true,
                            actions: true
                        },
                        components: {
                            table: () => import("./../views/pages/contact/components/customer-table.vue"),
                            actions: () => import("./../views/pages/contact/components/customer-details.vue")
                        }
                    },
                    {
                        path: "store-order",
                        name: "store order",
                        meta:{
                            roles: Contact,
                            title:'تواصل معنا - المشتركون'
                        },
                        components: {
                            table: () => import("./../views/pages/contact/components/store-table.vue")
                        }
                    },
                    {
                        path: "store-order/edit-info/:orderIndex",
                        name: "edit info order",
                        meta:{
                            roles: Contact,
                            title:'تواصل معنا - المشتركون - الطلبات'
                        },
                        props:{
                            table: true,
                            actions: true
                        },
                        components: {
                            table: () => import("./../views/pages/contact/components/store-table.vue"),
                            actions: () => import("./../views/pages/contact/components/order-edit-info.vue")
                        }
                    },
                    {
                        path: "store-order/notify/:orderIndex",
                        name: "notify order",
                        meta:{
                            roles: Contact,
                            title:'تواصل معنا - المشتركون - الإشعارات'
                        },
                        props:{
                            table: true,
                            actions: true
                        },
                        components: {
                            table: () => import("./../views/pages/contact/components/store-table.vue"),
                            actions: () => import("./../views/pages/contact/components/store-notify.vue")
                        }
                    },
                    {
                        path: "store-order/add-images/:orderIndex",
                        name: "add image order",
                        meta:{
                            roles: Contact,
                            title:'تواصل معنا - المشتركون - إضافة صور'
                        },
                        props:{
                            table: true,
                            actions: true
                        },
                        components: {
                            table: () => import("./../views/pages/contact/components/store-table.vue"),
                            actions: () => import("./../views/pages/contact/components/store-add-images.vue")
                        }
                    }
                ]
            },
            {
                path: "/report",
                name: "report",
                meta:{
                    roles: Admin,
                    title:'التقارير'
                },
                component: () => import("./../views/pages/report")
            },
            {
                path: "/shop",
                name: "shop",
                meta:{
                    roles: Shop,
                    title:'المشتركون'
                },
                component: () => import("./../views/pages/shop")
            },
            {
                path: "/shop/details/:id",
                name: "shop details",
                meta:{
                    roles: Shop,
                    title:'المشتركون - تفاصيل'
                },
                props: true,
                component: () => import("./../views/pages/shop/components/details.vue")
            },
            {
                path: "/shop/create",
                name: "shop create",
                meta:{
                    roles: Shop,
                    title:'المشتركون - إضافة'
                },
                props: true,
                component: () => import("./../views/pages/shop/components/create.vue")
            },
            {
                path: "/shop-request",
                name: "shop-request",
                meta:{
                    roles: Shop,
                    title:'طلبات الاشتراك'
                },
                component: () => import("./../views/pages/shop-request")
            },
            {
                path: "/shop-request/details/:id",
                name: "shop-request details",
                meta:{
                    roles: Shop,
                    title:'طلبات الاشتراك - تفاصيل'
                },
                props: true,
                component: () => import("./../views/pages/shop-request/components/details.vue")
            },
            {
                path: "/subscription",
                name: "subscription",
                meta:{
                    roles: Subscription,
                    title:'الإشتراكات'
                },
                component: () => import("./../views/pages/subscription"),
                redirect: "/subscription/-1",
                props: true,
                children: [
                    {
                        path: ":id",
                        name: "action subs",
                        meta:{
                            roles: Subscription,
                            title:'الإشتراكات - العمليات'
                        },
                        component: () => import("./../views/pages/subscription/components/action-subscription.vue"),
                        props: true
                    }
                ]
            },
            {
                path: "/user-info",
                name: "user info",
                meta:{
                    roles: Admin,
                    title:' المستفيدون'
                },
                props: true,
                component: () => import("./../views/pages/user-info"),
                children: [
                    {
                        path: ":userIndex",
                        name: "user info detials",
                        meta:{
                            roles: Admin,
                            title:'المستفيدون - تفاصيل'
                        },
                        props: true,
                        component: () => import("./../views/pages/user-info/components/details.vue")
                    }
                ]
            },
            {
                path: "/account",
                name: "account",
                meta:{
                    roles: Admin,
                    title:'الإعدادات - الحسابات'
                },
                props: true,
                component: () => import("./../views/pages/account"),
                redirect: "/account/-1",
                children: [
                    {
                        path: ":id",
                        name: "action account",
                        meta:{
                            roles: Admin,
                            title:'الإعدادات - الحسابات - العمليات'
                        },
                        component: () => import("./../views/pages/account/components/action-account"),
                        props: true
                    }
                ]
            },
            {
                path: "/category",
                name: "category",
                meta:{
                    roles: Admin,
                    title:'الإعدادات - التصنيفات'
                },
                component: () => import("./../views/pages/category")
            },
            {
                path: "/setting",
                name: "setting",
                meta:{
                    roles: Admin,
                    title:'الإعدادات - الإعدادات العامة'
                },
                redirect: "/setting/city/-1",
                component: () => import("./../views/pages/setting"),
                children:[
                    {
                        path: "city/:id",
                        name: "city",
                        meta:{
                            roles: Admin,
                            title:'الإعدادات - الإعدادات العامة - المحافظات'
                        },
                        props: {
                            default: true,
                            actions: true
                        },
                        components: {
                            default: () => import("./../views/pages/setting/components/city.vue"),
                            actions: () => import("./../views/pages/setting/components/action-city.vue"),
                        }
                    },
                    {
                        path: "area/:id",
                        name: "area",
                        meta:{
                            roles: Admin,
                            title:'الإعدادات - الإعدادات العامة - المناطق'
                        },
                        props: {
                            default: true,
                            actions: true,
                        },
                        components: {
                            default: () => import("./../views/pages/setting/components/area.vue"),
                            actions: () => import("./../views/pages/setting/components/action-area.vue"),
                        }
                    },
                    {
                        path: "schedule/:id",
                        name: "schedule",
                        meta:{
                            roles: Admin,
                            title:'الإعدادات - الإعدادات العامة الجدول الدوام'
                        },
                        props: {
                            default: true,
                            actions: true
                        },
                        components: {
                            default: () => import("./../views/pages/setting/components/schedule.vue"),
                            actions: () => import("./../views/pages/setting/components/action-schedule.vue"),
                        }
                    }
                ]
            },
            {
                path: "/about",
                name: "about",
                meta:{
                    roles: Admin,
                    title:'الإعدادات - حول'
                },
                component: () => import("./../views/pages/about")
            }
        ]
    },
    {
        path: "/log-in",
        component: () => import("./../views/auth/index.vue"),
        children: [
            {
                path: "/",
                name: "log in",
                meta:{
                    title:"I'm here تسجيل الدخول"
                },
                component: () => import("./../views/auth/components/log-in.vue"),
            },
            {
                path: "/auth/reset-password",
                name: "reset password",
                meta:{
                    title:'استعادة كلمة المرور'
                },
                component: () => import("./../views/auth/components/reset-password.vue"),
            },
            {
                path: "/auth/pass-code",
                name: "pass code",
                meta:{
                    title:'استعادة كلمة المرور'
                },
                component: () => import("./../views/auth/components/pass-code.vue"),
            },
            {
                path: "/auth/new-password",
                name: "new-password",
                meta:{
                    title:'استعادة كلمة المرور'
                },
                component: () => import("./../views/auth/components/new-password.vue"),
            }
        ]
    },
    {
        path: "/",
        redirect: "/dashboard"
    },
    {
        path: "/access-denied",
        meta:{
            title:'يمنع الوصول'
        },
        component: () => import("../views/error/access-denied.vue")
    },
    {
        path: "*",
        meta:{
            title:'الصفحة غير موجودة'
        },
        component: () => import("../views/error/not_found.vue")
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

export default router;
